import * as React from 'react';
import styled from 'styled-components';

const Footnotes = () => {
  return (
    <Paragraph>
      <FootnotesStar>*&nbsp;</FootnotesStar>
      <FootnotesText>
        This calculator is based on a model established by{' '}
        <a
          href="https://s3.us-east-2.amazonaws.com/kindbody-portal-static-files/cryo-predictor.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          this study
        </a>
      </FootnotesText>
    </Paragraph>
  );
};

export default Footnotes;

const FootnotesStar = styled.span``;
const FootnotesText = styled.span``;

const Paragraph = styled.p`
  ${({ theme }) => theme.typos.footnotes};
  color: ${({ theme }) => theme.colors.gray};
  padding-bottom: 30px;

  @media ${({ theme }) => theme.queries.tablet} {
    position: absolute;
    bottom: 0;

    span {
      display: inline-block;
    }

    ${FootnotesStar} {
      vertical-align: top;
    }

    ${FootnotesText} {
      width: 220px;
    }
  }
`;
